var borders_default = {
  "borderT": "r0w6s",
  "borderB": "bC5PB",
  "borderL": "_08zBb",
  "borderR": "nMLyq",
  "borderColorOverride": "bqaLc"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
